import { z } from 'zod';
import { SIDES } from '@fortem-monorepo/constants';
export const sideSchema = z.enum(SIDES);
